import { route } from 'ziggy';
import { Ziggy } from 'js@/ziggy.js';
import { languageCache } from 'vue@/translationCache.js';
import vueLanguageCache from 'vue@/vueLanguageCache.js';

const Global = {
    install(app) {
        // capitalize First Letter
        app.config.globalProperties.$cfl = (str) => {
            if (!str || !str.length) {
                return '';
            }
            return str.charAt(0).toUpperCase() + str.slice(1);
        };
        app.use(languageCache.i18n);
        app.use(vueLanguageCache);
        app.config.globalProperties.$t = (...args) => languageCache.i18n.global.t(...args);

        app.mixin({
            methods: {
                route: (name, params, absolute) => route(name, params, absolute, Ziggy),
            },
        });
    },
};

export default Global;
